<template>
    <footer class="hero-foot" id="w-footer">
        <div class="columns is-vcentered">
            <div class="column is-7 is-9-widescreen">
                <perfect-scrollbar :options="optionsScrollbar">
                    <div class="is-flex" style="padding: 1rem;">
                        <transition-group name="list-complete" class="list-tickets is-flex" tag="div">
                            <ticket v-for="ticket in ticketsCart"
                                    :key="ticket.id"
                                    :ticket="ticket"
                                    class="list-complete-item"
                            />
                        </transition-group>
                    </div>
                </perfect-scrollbar>
            </div>
            <div class="column is-5 is-3-widescreen">
                <div class="columns is-vcentered is-mobile">
                    <div class="column is-6 has-text-right">
                        <div class="price">
                            <div class="title is-size-5-mobile is-size-4-touch has-text-white-bis">
                                {{cartTotalPrice}}
                                <small>руб.</small>
                            </div>
                            <div class="subtitle is-size-7-mobile is-size-6-touch has-text-white-bis">без учета комиссии</div>
                        </div>
                    </div>
                    <div class="column is-6">
                        <button class="button is-info is-rounded is-medium is-fullwidth has-text-weight-bold is-size-7-mobile is-size-6-touch"
                                :disabled="cartCountTickets === 0 && cartTotalPrice <= 0"
                                @click="openModalFormDate()">
                            Купить
                        </button>

                        <b-modal :active.sync="isModalFormDateActive" has-modal-card trap-focus>
                            <modal-form-data></modal-form-data>
                        </b-modal>

                    </div>
                </div>
            </div>
        </div>
    </footer>
</template>

<script>
    import {PerfectScrollbar} from 'vue2-perfect-scrollbar'
    import Ticket from './Ticket';
    import {mapGetters, mapState} from 'vuex'
    import ModalFormData from './modals/ModalFormData';

    export default {
        name: "WFooter",
        components: {
            PerfectScrollbar, Ticket, ModalFormData
        },
        data() {
            return {
                optionsScrollbar: {
                    suppressScrollY: true,
                    useBothWheelAxes: true
                },
                isModalFormDateActive: false,
            }
        },
        computed: {
            ...mapState({
                ticketsCart: state => state.cart.items,
            }),
            ...mapGetters('cart', {
                cartTotalPrice: 'cartTotalPrice',
                cartCountTickets: 'cartCountTickets'
            })
        },
        methods: {
            openModalFormDate() {
                this.isModalFormDateActive = true;
            }
        }
    }
</script>

<style scoped lang="scss">
    .hero {
        &-foot {
            min-height: 6.5rem;
            display: flex;
            flex-direction: column;
            justify-content: center;

            .price {
                .title,
                .subtitle {
                    /*color: var(--main-text-color);*/
                }

                .subtitle {
                    opacity: .5;
                }
            }
        }
    }

    .list-tickets {
        flex-direction: row-reverse;
    }

    .ps {
        margin: -1rem;
    }

</style>
